import React from 'react';
// import SarasDnDProvider from '../../../../library/hooks/bdnd/SarasDnDProvider';
// import { SarasDnDTypes } from '../../../../library/hooks/bdnd/SarasDnDTypes';
// import useSarasDnDManager from '../../../../library/hooks/bdnd/useSarasColumnDnDManager'
import SarasDnDProvider from '../../../../library/hooks/dndkit/SarasDnDProvider';
import { SarasDnDTypes } from '../../../../library/hooks/dndkit/SarasDnDTypes';
import useSarasDnDManager from '../../../../library/hooks/dndkit/useSarasColumnDnDManager'
import SarasModal from '../../../../library/container/popup/SarasModal';
import SarasDialogCustomAction from '../../../../library/container/popup/SarasDialogCustomAction';
import SarasButton from '../../../../library/input/buttons/button/SarasButton';
import ColumnSelectorDNDList from './ColumnSelectorDNDList';
import { getColumnsGroupForManager, resetColumnsSetting, saveColumnPreference } from '../components/DocSCFunctions';

const ColumnSelector = (props) => {
    const { viewData, onConfirm, onCancel } = props;

    const [showKeys, setShowKeys] = React.useState([]);
    const [hideKeys, setHideKeys] = React.useState([]);

    React.useEffect(() => {
        if(viewData.columns)
        {
            let { show, hide } = getColumnsGroupForManager(viewData.columns);

            setShowKeys(show);
            setHideKeys(hide);
        }
    }, [viewData]);

    const updateSortKeys = (rowKeys) => {
        return rowKeys.map((rowKey, index) => ({
            ...rowKey,
            sortKey: index + 1,
        }));
    }

    const onDragEnd = (result) => {
        // console.log("column selector drag end", viewData, showKeys, result);

        if(!result || !result.destination) return;

        if(result.source.droppableId !== result.destination.droppableId)
        {
            const sourceList = result.source.droppableId === "visible" ? showKeys : hideKeys;
            const destinationList = result.destination.droppableId === "visible" ? showKeys : hideKeys;
            const movedItem = sourceList[result.source.index];

            if(!movedItem) return;

            const newSourceList = sourceList.filter((item, index) => index !== result.source.index);
            const newDestinationList = [...destinationList];

            newDestinationList.splice(result.destination.index, 0, movedItem);

            const normalizedSourceList = updateSortKeys(newSourceList);
            const normalizedDestinationList = updateSortKeys(newDestinationList);

            if(result.source.droppableId === "visible")
            {
                setShowKeys(normalizedSourceList);
                setHideKeys(normalizedDestinationList);
            }
            else
            {
                setHideKeys(normalizedSourceList);
                setShowKeys(normalizedDestinationList);
            }

            return;
        }

        if(result.destination.droppableId === "visible")
        {
            let dropResult = sarasDnDManager.onDragEnd(viewData.columns, showKeys, result);
            
            if(!dropResult) return;

            setShowKeys(dropResult.rowKeys);
        }
        else
        {
            let dropResult = sarasDnDManager.onDragEnd(viewData.columns, hideKeys, result);
            
            if(!dropResult) return;

            setHideKeys(dropResult.rowKeys);
        }
    }

    const onToggleVisibility = (rowKey, isHidden) => {
        // console.log("column selector toggle visibility", rowKey, isHidden);

        let sortKey = viewData.columns[rowKey].sortKey;

        //move the rowKey - if it is isHidden then check in the hideKeys and move to showKeys and vice versa
        if(isHidden)
        {
            //move to showKeys
            let newHideKeys = hideKeys.filter( key => key.columnKey !== rowKey);
            let newShowKeys = [...showKeys, { columnKey: rowKey, sortKey: sortKey }];

            //sort the keys by sortKey before setting to the state
            newShowKeys.sort( (a, b) => a.sortKey - b.sortKey );

            setHideKeys(newHideKeys);
            setShowKeys(newShowKeys);
        }
        else
        {
            //move to hideKeys
            let newShowKeys = showKeys.filter( key => key.columnKey !== rowKey);
            let newHideKeys = [...hideKeys, { columnKey: rowKey, sortKey: sortKey }];

            setShowKeys(newShowKeys);
            setHideKeys(newHideKeys);
        }
    }

    const sarasDnDManager = useSarasDnDManager(SarasDnDTypes.CARD, true);

    const cancelClicked = () => {
        if(onCancel) onCancel();
    };

    const onUpdateSuccess = (response, requestObject) => {
        if(onConfirm) onConfirm();
    };

    const confirmClicked = () => {
        //call code to reorder on server
        //combine the showKeys and hideKeys, and send it to the server as json compatible string
        //before combining update the state isHidden to 0 for showKeys and 1 for hideKeys
        let combinedKeys = [...showKeys, ...hideKeys].map(item => {
            return {
                ...item,
                isHidden: hideKeys.find(hideItem => hideItem.columnKey === item.columnKey) ? 1 : 0
            };
        });

        // console.log("column selector confirm", combinedKeys);

        saveColumnPreference(viewData.key, combinedKeys, onUpdateSuccess);
    };

    const onReset = () => {
        let { show, hide } = resetColumnsSetting(viewData.columns);
        
        setShowKeys(show);
        setHideKeys(hide);
    };

    if (!viewData || !viewData.columns)
        return (null)

    return (
        <SarasModal enableModal={true} modelState={true} >
            <SarasDialogCustomAction contentStyle={{ width: '520px', height: '400px' }}
                title="Choose Columns"

                actionChildren={
                    <>
                        <div className="uiMarginT10" style={{clear: "both"}}>
                            <div className="phAction">
                                <div className='uiFlexDistributed'>
                                    <SarasButton className="uiSecondaryAction" onClick={onReset}>Reset</SarasButton>
                                    <div className="uiFlexBox">
                                        <SarasButton starIcon="confirm" className="uiSaveAction" onClick={confirmClicked}>Update</SarasButton>
                                        <SarasButton starIcon="cancel" className="uiCancelAction" onClick={cancelClicked}>Cancel</SarasButton>
                                    </div>
                                </div>
                            </div>
                            <div style={{clear: "both"}} />
                        </div>
                    </>
                }
            >
                <SarasDnDProvider onDragEnd={onDragEnd} sarasDnDManager={sarasDnDManager}>
                    <div className="uiFlexDistributed uiFlexBoxStart">
                        <div>
                            <div className="uiBold">Visible Columns</div>
                            <ColumnSelectorDNDList groupKey={"visible"}
                                viewData={viewData} 
                                rowKeys={showKeys}
                                onToggleVisibility={onToggleVisibility}
                                isHidden={false}
                                sarasDnDManager={sarasDnDManager} />
                        </div>
                        <div>
                            <div className="uiBold">Hidden Columns</div>
                            <ColumnSelectorDNDList groupKey={"hidden"}
                                viewData={viewData} 
                                rowKeys={hideKeys}
                                onToggleVisibility={onToggleVisibility}
                                isHidden={true}
                                sarasDnDManager={sarasDnDManager} />
                        </div>
                    </div>
                </SarasDnDProvider>
            </SarasDialogCustomAction>
        </SarasModal>
    )
}

export default ColumnSelector;
